<template lang="pug">
    div(
        :key="video.id"
        :class="wistiaClass"
    ) &nbsp;
        div(class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;")
            img(ref="wistiaImage" :src="swatch" :data-src="swatch" alt="" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;transform: scale(1.05)" onload="this.parentNode.style.opacity=1;")
</template>

<script>
import wistiaMixin from './mixin'

export default {
    mixins: [wistiaMixin],
    props: {
        video: {
            type: Object,
            required: true,
        },
        imageUrl: {
            type: String,
            default: '',
        },
        disableAutoPause: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        // FYI this loops
        wistiaClass() {
            return [
                'wistia_embed',
                `wistia_async_${this.video.id}`,
                'videoFoam=true',
                'autoPlay=true',
                'muted=true',
                'silentAutoPlay=true',
                'controlsVisibleOnLoad=false',
                'settingsControl=false',
                'playbar=false',
                'playButton=false',
                'smallPlayButton=false',
                'volumeControl=false',
                'fullscreenButton=false',
                'endVideoBehavior=loop',
                ...(this.imageUrl ? [`stillUrl=${this.imageUrl}`] : []),
            ].join(' ')
        },
        swatch() {
            return `https://fast.wistia.com/embed/medias/${this.video.id}/swatch`
        },
    },
    mounted() {
        this.loadWistiaVideo({ disableAutoPause: this.disableAutoPause })
    },
}
</script>
